import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'mdi',
  theme: {
    // primary: '#2a95e8',
    primary: '#f10102',
    secondary: '#ff9100',
    accent: '#f47e2c',

    //Customize
    accent2: '#0a2c47',
    profile: '#ee2b2b',
    categories: '#a3138a',
    orders: '#ff44e8',
    wallet: '#a322ff',
    fav: '#46c0ff',
    voucher: '#0d46f5',
    sharing: '#03abd5',
  }
})
